<!-- 全部客户 -->
<template>
    <div class="clientTable">
        <header class="header">
            <el-radio v-model="radio" label="1">全部({{ total }})</el-radio>
            <el-radio v-model="radio" label="2">企业客户(0)</el-radio>
            <el-radio v-model="radio" label="3">个人客户(0)</el-radio>
        </header>
        <div class="center">
            <div style="margin-bottom: 0.1rem;justify-content: space-between;" class="centerBox">
                <div class="centerBox">
                    <p>查询关键词</p>
                    <el-input style="width: 1.2rem; margin-right: 0.1rem" size="small" v-model="input"
                        placeholder="用户昵称"></el-input>
                    <el-input style="width: 1.2rem; margin-right: 0.1rem" size="small" v-model="input"
                        placeholder="真实姓名"></el-input>
                    <el-input style="width: 1.2rem; margin-right: 0.1rem" size="small" v-model="input"
                        placeholder="用户ID"></el-input>
                    <el-input style="width: 1.2rem; margin-right: 0.1rem" size="small" v-model="input"
                        placeholder="注册手机 "></el-input>
                    <p>性别</p>
                    <el-select style="width: 1.2rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <p>会员等级</p>
                    <el-select style="width: 1.2rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <p>达人</p>
                    <el-select style="width: 1.2rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <el-button style="color: #fff; background-color: #e69c37" size="small">搜索</el-button>
            </div>
            <div class="centerBox">
                <p>生日日期</p>
                <el-date-picker v-model="value" type="date" style="width: 1.3rem; margin-right: 0.1rem" size="small"
                    placeholder="选择日期">
                </el-date-picker>
                <p>注册时段</p>
                <el-date-picker style="margin-right: 0.1rem" size="small" v-model="value" type="daterange"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
                <p>订单数量</p>
                <el-input style="width: 1rem; margin-right: 0.1rem" size="small" v-model="input"
                    placeholder="数字"></el-input>
                <p>至</p>
                <el-input style="width: 1rem; margin-right: 0.1rem" size="small" v-model="input"
                    placeholder="数字"></el-input>
                <p>所属机构</p>
                <el-select style="width: 1rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <p>所属达人</p>
                <el-select style="width: 1rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <p>消费力</p>
                <el-select style="width: 1rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <footer class="footer">
            <div class="left">
                符合条件共:客户(<span>0</span>)
            </div>
            <div class="right">
                <el-select style="width: 1.5rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
                    <el-option v-for="item in Boptions1" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select style="width: 1.5rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
                    <el-option v-for="item in Boptions2" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select style="width: 1.5rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
                    <el-option v-for="item in Boptions3" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select style="width: 1.5rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
                    <el-option v-for="item in Boptions4" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select style="width: 1.5rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
                    <el-option v-for="item in Boptions5" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </footer>
        <el-table :data="tableData" :header-cell-style="{
            backgroundColor: '#FDEFE7', color: '#000000'
        }" ref="multipleTable" @selection-change="handleSelectionChange" style="width: 100%" border>
            <el-table-column align="center" type="selection" width="55"> </el-table-column>
            <el-table-column align="center" prop="date" label="客户头像"> </el-table-column>
            <el-table-column align="center" prop="date" label="昵称"> </el-table-column>
            <el-table-column align="center" prop="date" label="真实姓名"> </el-table-column>
            <el-table-column align="center" prop="id" label="用户ID"> </el-table-column>
            <el-table-column align="center" prop="date" label="性别"> </el-table-column>
            <el-table-column align="center" prop="date" label="生日"> </el-table-column>
            <el-table-column align="center" prop="phoneNumber" label="手机号"> </el-table-column>
            <el-table-column align="center" prop="date" label="订单数量">
                <template slot="header">
                    <span style="margin-right: 5px;">订单数量</span>
                    <i class="el-icon-sort" style="color: rgb(236, 101, 26); font-weight: 600; cursor: pointer;"></i>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="date" label="是否分销"> </el-table-column>
            <el-table-column align="center" prop="date" label="消费金额"> </el-table-column>
            <el-table-column align="center" prop="date" label="可用积分">
                <template slot="header">
                    <span style="margin-right: 5px;">可用积分</span>
                    <i class="el-icon-sort" style="color: rgb(236, 101, 26); font-weight: 600; cursor: pointer;"></i>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="date" label="可用卡劵">
                <template slot="header">
                    <span style="margin-right: 5px;">可用卡劵</span>
                    <i class="el-icon-sort" style="color: rgb(236, 101, 26); font-weight: 600; cursor: pointer;"></i>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="date" label="注册时间">
                <template slot="header">
                    <span style="margin-right: 5px;">注册时间</span>
                    <i class="el-icon-sort" style="color: rgb(236, 101, 26); font-weight: 600; cursor: pointer;"></i>
                </template>
                <template slot-scope="scope">{{ scope.row.createTime | dateFormatHms }}</template>
            </el-table-column>
            <el-table-column align="center" prop="date" label="操作"> </el-table-column>
        </el-table>
        <Pagination :page-size="5" @current-change="qhPages" :total="total"></Pagination>
    </div>
</template>
  
<script>
import Pagination from "@/components/Pagination.vue";
import Api from '@/components/Api/PlanApi.js'
export default {
    components: {
        Pagination,
    },
    data() {
        return {
            tableData: [],
            total: 0,
            page: 1,
            radio: '1',
            input: "",
            value: "",
            options: [
                {
                    value: "1",
                    label: "默认好评",
                },
                {
                    value: "2",
                    label: "非默认好评",
                },
            ],
            Boptions1: [
                {
                    value: "1",
                    label: "群发短信",
                },
            ],
            Boptions2: [
                {
                    value: "1",
                    label: "群发小程序推送",
                },
            ],
            Boptions3: [
                {
                    value: "1",
                    label: "设置标签",
                },
            ],
            Boptions4: [
                {
                    value: "1",
                    label: "赠送优惠卷",
                },
            ],
            Boptions5: [
                {
                    value: "1",
                    label: "导出数据",
                },
            ],
        };
    },
    computed: {},
    watch: {},
    methods: {
        qhPages(val) {
            this.page = val
            this.getData()
        },
        handleSelectionChange() { },
        getDatas() {
            let obj = {
                page: this.page,
                q: {},
                size: 5
            }
            new Api("plan").customizerCustomerList(obj).then((res) => {
                if (res.status === 200) {
                    console.log(res, '时刻打开打开看');
                    this.total = res.data.total
                    this.tableData = res.data.records
                } else {
                    this.$message({
                        type: "error",
                        message: res.statusText,
                    });
                }
            }).catch((err) => {
                this.$message({
                    type: "error",
                    message: '加载失败!',
                });
            });
        }
    },
    created() { },
    mounted() {
        this.getDatas()
    },
};
</script>
<style lang="scss" scoped>
.clientTable {
    background-color: #fff;
    padding: 0.23rem 0.3rem;

    .header {
        margin-bottom: 0.2rem;
    }

    .center {
        padding: 0.2rem;
        background-color: #f1f1f1;
        margin-bottom: 0.2rem;

        p {
            margin-right: 0.1rem;
        }

        .centerBox {
            display: flex;
            align-items: center;
        }
    }

    .footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.2rem;

        .left {
            span {
                color: #dc7039;
                font-weight: bold;
            }
        }

        .right {
            margin-left: auto;

        }
    }
}
</style>
  